import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import defined from '~app/core/defined';
import { formatLicense } from '~app/core/license';

import WildlifeImage from './WildlifeImage';

const WildlifeImageContainer = ({selectedSpeciesContent, selectedSpeciesImage}) => {
  if (defined(selectedSpeciesContent)) {
    const imageCredit = selectedSpeciesContent.image_citation;
    const licenseUrl = selectedSpeciesContent.image_license;
    const sourceUrl = selectedSpeciesContent.image_source_url;
    const hasImage =
      defined(selectedSpeciesContent.image_sheet) &&
      defined(selectedSpeciesContent.image_x) &&
      defined(selectedSpeciesContent.image_y) &&
      defined(selectedSpeciesContent.image_width) &&
      defined(selectedSpeciesContent.image_height);
    const speciesBinomial = selectedSpeciesContent.binomial;
    const imageBinomial = selectedSpeciesContent.image_binomial;
    const imageGenus = selectedSpeciesContent.image_genus;

    return (
      <div className="WildlifeImageContainer">
        <WildlifeImage
          selectedSpeciesContent={selectedSpeciesContent}
          selectedSpeciesImage={selectedSpeciesImage}
        />
        {renderCredit(imageCredit)}
        {renderLicense(licenseUrl)}
        {renderSourceLink(sourceUrl)}
        {renderSpeciesDisclaimer(hasImage, speciesBinomial, imageBinomial, imageGenus)}
      </div>
    );
  }
  return null;
};

function renderCredit(imageCredit) {
  if (defined(imageCredit)) {
    return (
      <p className="WildlifeImageContainer__credit">
        {imageCredit}
      </p>
    );
  }
}

function renderLicense(licenseUrl) {
  if (defined(licenseUrl)) {
    const licenseText = formatLicense(licenseUrl);
    if (isValidUrl(licenseUrl)) {
      return (
        <a className={classNames(
            "WildlifeImageContainer__license",
            "WildlifeImageContainer__license--link",
          )}
          href={licenseUrl}
          target="_blank"
          rel="noopener"
        >
          {licenseText}
        </a>
      );
    }
    else {
      return (
        <p className="WildlifeImageContainer__license">
          {licenseText}
        </p>
      );
    }
  }
}

function renderSourceLink(sourceUrl) {
  if (defined(sourceUrl) && isValidUrl(sourceUrl)) {
    return (
      <a className="WildlifeImageContainer__source"
        href={sourceUrl}
        target="_blank"
        rel="noopener"
      >
        View Online
      </a>
    );
  }
}

function renderSpeciesDisclaimer(hasImage, speciesBinomial, imageBinomial, imageGenus) {
  if (hasImage) {
    if (!defined(imageBinomial)) {
      // If we don't have an image binomial at all, then we the image represents the genus
      // as a whole, but we don't know exactly which species is pictured.
      return (
        <p className="WildlifeImageContainer__disclaimer">
          {`Representative photo of the genus: ${imageGenus}`}
        </p>
      );
    }
    else if (imageBinomial !== speciesBinomial) {
      return (
        <p className="WildlifeImageContainer__disclaimer">
          {`Photo of a closely related species: ${imageBinomial}`}
        </p>
      );
    }
  }
}

function isValidUrl(url) {
  // damato: This may not be strictly accurate, but it should work for our
  // purpose (which is to identify an obviouly incorrect url for the Gray Whale
  // off the coast of Maryland).
  return url.startsWith("http://") || url.startsWith("https://");
}

WildlifeImageContainer.propTypes = {
  selectedSpeciesContent: PropTypes.object,
  selectedSpeciesImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default WildlifeImageContainer;



// WEBPACK FOOTER //
// ./src/components/WildlifeImageContainer.js